module.exports = new __parcel__URL__("NoResultsImage.ca37f2fe.svg").toString();